import { apiRegistry } from '../../../common/infra/apiRegistry'
import { favoritesMem } from '../mem/favoritesMem'

apiRegistry.registerPostApi('addFavorite', async (req) => {
  const newFavorite = {
    id: Date.now().toString(),
    wordId: req.wordId,
    word: req.word,
    partOfSpeech: req.partOfSpeech,
    briefMeaning: req.briefMeaning,
    favoritedAt: new Date().toISOString()
  }

  favoritesMem[req.wordId] = newFavorite
  return { success: true }
})
